import config from '../utils/config';

import {
  getRequest,
  postRequest
} from '../aws/aws_rest_client';

const { api } = config;
const { methods } = api;

const createCreativecontent = async (parameters) =>
  postRequest(
    methods.creativecontent.create,
    {
      body: parameters
    }
  );

const creativecontentInfo = async (parameters) =>
  getRequest(
    methods.creativecontent.info,
    {
      queryStringParameters: parameters
    }
  );

const deleteCreativecontent = async (parameters) =>
  postRequest(
    methods.creativecontent.delete,
    {
      body: parameters
    }
  );

const listCreativecontent = async (
  parameters,
  reducer
) =>
{
  console.log(reducer);
  getRequest(
    methods.creativecontent.list,
    {
      queryStringParameters: parameters
    },
    reducer
  );
}

const updateCreativecontent = async (parameters) =>
  postRequest(
    methods.creativecontent.update,
    {
      body: parameters
    }
  );

export {
  createCreativecontent,
  creativecontentInfo,
  deleteCreativecontent,
  listCreativecontent,
  updateCreativecontent
};
